import { z } from 'zod';

const customerGroupsSchema = z.object({
    id: z.string(),
});

export const CustomerGroupDTO = z.object({
    count: z.number(),
    limit: z.number(),
    offset: z.number(),
    customerGroups: z.array(customerGroupsSchema).optional(),
});

export type CustomerGroupDTO = z.infer<typeof CustomerGroupDTO>;
